import mark from "../assets/icons/mark.svg";
import { cx } from "../lib/cx";

/**
 * SemantiCAD Brand mark (Figma 2:15) — two flags with the brand gap, 72×72.
 */
export function Mark({ className }: { className?: string }) {
  return (
    <img
      src={mark}
      alt=""
      className={cx("block size-9 max-w-none shrink-0", className)}
      aria-hidden="true"
    />
  );
}
